exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "order {\n  display: block;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\norder .order-summary {\n  margin-top: 30px;\n}\norder .order-summary table {\n  text-align: right;\n}\norder .order-summary table tbody tr td:last-child {\n  padding-left: 30px;\n}", ""]);

// exports
